/* eslint-disable no-console */
const logger = error => {
  if (process.env.REACT_APP_STAGE === 'dev') {
    console.trace(error);
  }
};

export default logger;
